"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubdomain = exports.isAllowedSubdomain = void 0;

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _lodash2 = _interopRequireDefault(require("lodash.isnil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAllowedSubdomain = function isAllowedSubdomain() {
  var subdomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "www";
  var subdomains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.values(subdomains).includes(subdomain);
};

exports.isAllowedSubdomain = isAllowedSubdomain;

var getSubdomain = function getSubdomain() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var subdomains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultSub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "rentspree";
  if ((0, _lodash2.default)(url) || (0, _lodash.default)(url)) return "rentspree";
  var fullPath = url.replace(/http[s]?:\/\//, "");
  var subdomain = fullPath.slice(0, fullPath.indexOf("."));
  subdomain = (0, _lodash2.default)(subdomain) || (0, _lodash.default)(subdomain) ? defaultSub : subdomain;

  if (!(0, _lodash.default)(subdomains)) {
    return isAllowedSubdomain(subdomain, subdomains) ? subdomain : defaultSub;
  }

  return subdomain;
};

exports.getSubdomain = getSubdomain;